var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLobbyBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9166 9.08332V3.41666C17.9166 2.16666 17.3833 1.66666 16.0583 1.66666H12.6916C11.3666 1.66666 10.8333 2.16666 10.8333 3.41666V9.08332C10.8333 10.3333 11.3666 10.8333 12.6916 10.8333H16.0583C17.3833 10.8333 17.9166 10.3333 17.9166 9.08332Z",
    fill: "#514EF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16658 10.9167V16.5833C9.16658 17.8333 8.63325 18.3333 7.30825 18.3333H3.94159C2.61659 18.3333 2.08325 17.8333 2.08325 16.5833V10.9167C2.08325 9.66666 2.61659 9.16666 3.94159 9.16666H7.30825C8.63325 9.16666 9.16658 9.66666 9.16658 10.9167Z",
    fill: "#514EF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9166 16.5833V14.25C17.9166 13 17.3833 12.5 16.0583 12.5H12.6916C11.3666 12.5 10.8333 13 10.8333 14.25V16.5833C10.8333 17.8333 11.3666 18.3333 12.6916 18.3333H16.0583C17.3833 18.3333 17.9166 17.8333 17.9166 16.5833Z",
    fill: "#514EF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16658 5.74999V3.41666C9.16658 2.16666 8.63325 1.66666 7.30825 1.66666H3.94159C2.61659 1.66666 2.08325 2.16666 2.08325 3.41666V5.74999C2.08325 6.99999 2.61659 7.49999 3.94159 7.49999H7.30825C8.63325 7.49999 9.16658 6.99999 9.16658 5.74999Z",
    fill: "#514EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobbyBold);
export default __webpack_public_path__ + "static/media/lobbyBold.b05a4eceb0c3e676f8300c75885d1055.svg";
export { ForwardRef as ReactComponent };